export const actionTypes = {
  SET_TYPE: 'MESSAGES.LIST_FILTERS.SET_TYPE',
  SET_PERIOD: 'MESSAGES.LIST_FILTERS.SET_PERIOD',
};

export function setType(type) {
  return {
    type: actionTypes.SET_TYPE,
    payload: type,
  };
}

export function setPeriod(periodObject) {
  return {
    type: actionTypes.SET_PERIOD,
    payload: periodObject,
  };
}
